import { v4 as uuidv4 } from 'uuid';

const SESSION_ID_KEY = 'sessionId';

/**
 * Get or create a session ID for the current browser session.
 * Persists in sessionStorage (survives navigations, clears on tab close).
 *
 * @return {string}
 */
export function getSessionId(): string {
	const existing = sessionStorage.getItem(SESSION_ID_KEY);
	if (existing) {
		return existing;
	}

	const sessionId = uuidv4();
	sessionStorage.setItem(SESSION_ID_KEY, sessionId);
	return sessionId;
}
